export default "__VITE_ASSET__BoeQ0h0f__"